import { render, staticRenderFns } from "./shortAnswerPC.vue?vue&type=template&id=abc2fd02&scoped=true&"
import script from "./shortAnswerPC.vue?vue&type=script&lang=js&"
export * from "./shortAnswerPC.vue?vue&type=script&lang=js&"
import style0 from "./shortAnswerPC.vue?vue&type=style&index=0&id=abc2fd02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc2fd02",
  null
  
)

export default component.exports